import {DestroyRef, inject, provideAppInitializer} from '@angular/core';
import {Actions, ofActionDispatched, Store} from '@ngxs/store';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {
  GetOrgsAction,
  GetOrgsFailureAction,
  GetOrgsSuccessAction,
  SetOrgAction,
  SwitchOrgAction
} from '../+state/orgs/actions';
import {ORG_SERVICE} from '../services/org.service';
import {switchMap} from 'rxjs';

export const provideGetOrgsInit = provideAppInitializer(() => {
  const actions = inject(Actions);
  const store = inject(Store);
  const orgService = inject(ORG_SERVICE);
  const destroyRef = inject(DestroyRef);

  actions.pipe(
    ofActionDispatched(GetOrgsAction),
    switchMap(() => orgService.getOrgs()
      .pipe(
        switchMap(res => {
          const {data, error} = res;
          const action = !error ? new GetOrgsSuccessAction(data ?? [])
            : new GetOrgsFailureAction(error);
          return store.dispatch(action);
        })
      )
    ),
    takeUntilDestroyed(destroyRef)
  ).subscribe();
});

export const provideSetOrgInit = provideAppInitializer(() => {
  const actions = inject(Actions);
  const store = inject(Store);
  const orgService = inject(ORG_SERVICE);
  const destroyRef = inject(DestroyRef);

  actions.pipe(
    ofActionDispatched(SwitchOrgAction),
    switchMap(({id}) => orgService.setActiveOrg(id).pipe(
      switchMap(() => store.dispatch(new SetOrgAction(id)))
    )),
    takeUntilDestroyed(destroyRef)
  ).subscribe();
});

export const provideSetActiveOrgInit = provideAppInitializer(() => {
  const store = inject(Store);
  const orgService = inject(ORG_SERVICE);
  const orgId = orgService.getActiveOrgId();
  if (orgId) {
    store.dispatch(new SetOrgAction(orgId));
  }
});
